export default __webpack_public_path__ + "static/Group-118@2x-1ec1773dece5766c281affc32be5ce77.png";